import React, { useEffect } from "react";
import "./Faq.scss";
import { styled } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";

import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import faqBird from "../../assets/images/faqBird.png";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  backgroundColor: `transparent`,
  marginTop: 10,
  marginBottom: 10,
  paddingTop: 20,
  cursor: `pointer`,
  borderTopColor: `rgba(255, 255, 255, 1)`,
  borderTopStyle: "solid",
  borderTopWidth: 2,

  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => <MuiAccordionSummary {...props} />)(
  ({ theme }) => ({
    backgroundColor: "transparent",
    flexDirection: "row-reverse",
    padding: 0,
  })
);

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: 0,
}));

function Faq() {
  const faq = [
    {
      id: "faq1",
      question: "​​What is Play-to-Earn?",
      answer:
        "As technology builders, we have seen first-hand how technology has changed the world for the better. Our intention is to create a worldwide community of techno-optimists. The medium is the message here: The LABverse pushes the boundaries of emerging technologies to tell the tale.",
    },
    {
      id: "faq2",
      question: "What is an NFT",
      answer:
        "An NFT is a unique, immutable, and verifiable representation of a physical or digital item on a blockchain. This technology allows important concepts of physical ownership, such as provenance and authentication, to be transferred digitally. In video games, NFTs also open up the potential for in-game assets to be interoperable with a range of different games and platforms.",
    },
    {
      id: "faq3",
      question: "How do NFT games work?",
      answer:
        "There will be 9876 exclusive bots. Why 9876? It is the countdown to build a better future. Each bot belongs to a particular generation with its own unique quirks. These generations are the OG’s, the blazers, the aurics and the child prodigy. In the LABverse you will meet the coolest characters, ranging from the chef to the construction worker. Each hardworking bot symbolizes the spirit of building our brave new world.",
    },
    {
      id: "faq4",
      question:
        "How do people earn from NFT games? Where does the money come from?",
      answer:
        "The year is 2077 or 2090 and the world has been destroyed and only the LABs can save it. Nope, that’s not our story. Our story has to be as unique as the LABverse and it’s characters. And that’s possible only when it comes from our community, our co creators. We will put out keywords that describe the LABverse and write our history together. Can’t wait to see what we create. ",
    },
  ];

  return (
    <section className="faq" id="faq">
      <img src={faqBird} alt="" className="faqBird" />

      <div className="container">
        <h2 className="secheading">Frequently Asked Questions</h2>

        <div className="faq__container">
          {faq.map((item) => {
            return (
              <FaqItem
                question={item.question}
                answer={item.answer}
                id={item.id}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default Faq;

const FaqItem = ({ question, answer, id }) => {
  return (
    <Accordion key={id}>
      <AccordionSummary aria-controls="panel1a-content" id="panel1a-header">
        <h4 className="faq__question">{question}</h4>
      </AccordionSummary>
      <AccordionDetails>
        <p
          className="faq__answer"
          dangerouslySetInnerHTML={{ __html: answer }}
        ></p>
      </AccordionDetails>
    </Accordion>
  );
};
